import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import Thankyou from '@/components/Thankyou'
import Summary from '@/components/Summary'
import RoomSelect from '@/components/RoomSelect'
import DateSelect from '@/components/DateSelect'
import Detail from '@/components/Detail'
import BookingCode from '@/components/BookingCode'
import Maintenance from '@/components/Maintenance'
import ForgotCode from '@/components/ForgotCode'

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'welcome',
			component: Welcome
		},
		{
			path: '/roomSelect',
			name: 'roomSelect',
			component: RoomSelect
		},
		{
			path: '/bookingCode',
			name: 'bookingCode',
			component: BookingCode
		},
		{
			path: '/dateSelect',
			name: 'dateSelect',
			component: DateSelect
		},
		{
			path: '/details',
			name: 'details',
			component: Detail
		},
		{
			path: '/summary',
			name: 'summary',
			component: Summary
		},
		{
			path: '/thankyou',
			name: 'thankyou',
			component: Thankyou
		},
		{
			path: '/maintenance',
			name: 'maintenance',
			component: Maintenance
		},
		{
			path: '/forgot',
			name: 'forgot',
			component: ForgotCode
		}
	],
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})



// WEBPACK FOOTER //
// ./src/router/index.js